import React, { Fragment } from "react";
import { useDevicePermissionsStore } from "../storez/DevicePermissionsStore";

/**
 * @deprecated Use {@link ../components/AuthorizationWrapper} instead.
 */
export default class AuthorizationWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      devicePermissions: useDevicePermissionsStore.getState().permissions,
      supportAdmin: useDevicePermissionsStore.getState().supportAdmin,
    };
  }

  componentWillMount() {
    this.unsubscribe = useDevicePermissionsStore.subscribe(this.onChange);
  }

  componentWillUnmount() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = undefined;
    }
  }

  onChange = () => {
    this.setState({
      devicePermissions: useDevicePermissionsStore.getState().permissions,
      supportAdmin: useDevicePermissionsStore.getState().supportAdmin,
    });
  };

  render() {
    if (this.state.supportAdmin || !this.props.allowedRoles) {
      return <Fragment>{this.props.children}</Fragment>;
    }
    for (let permission of this.state.devicePermissions) {
      if (this.props.allowedRoles.indexOf(permission) !== -1) {
        return <Fragment>{this.props.children}</Fragment>;
      }
    }
    return <Fragment />;
  }
}
